import api from '../api/axios';

const getByDateRange = (startDate, endDate) => {
  const response = api.get(`/installation-schedule?startDate=${startDate}&endDate=${endDate}`);
  return response;
};

const getByDay = (date) => {
  const response = api.get(`/installation-schedule/day?date=${date}`);
  return response;
};

const getAvailableResources = (date) => {
  return api.get(`/installation-schedule/available-resources/${date}`);
};

const installationScheduleServices = {
  getByDateRange,
  getByDay,
  getAvailableResources,
};

export default installationScheduleServices;

